//=include _base.js

$all('.indeterminate > input').forEach((item) => item.indeterminate = true);
